module.exports = __webpack_public_path__ + "static/media/cart_icon.581602cd.svg";